import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import {
  RecomendadorAgrupacion,
  ColectivasAgrupacion,
  CategoriaColectivaIdiomas,
  PermisosRecomendador,
  PreguntaRecomendador,
  Recomendador,
  ConsultarIdOpcionRecomendador
} from '../../model/recomendador.model';

@Injectable({
  providedIn: 'root'
})
export class RecomendadorApiService extends BaseApiService {

  getPrecioProductos(productos: any[]): Observable<any> {
    return this.invocarSeguros<any>(
      'POST',
      'salud/recomendador/productos/colectivos-pymes/precio',
      productos
    );
  }

  consultarCanalUsuario(): Observable<any> {
    return this.invocarMediadores<any>(
      'GET',
      'mediador/canal'
    );
  }

  getAgrupacionesRecomendador(idRecomendador: number, idOpcion: number, esDental: Boolean): Observable<RecomendadorAgrupacion[]> {
    return this.invocarSeguros<RecomendadorAgrupacion[]>('GET', `salud/recomendador/agrupaciones/${idRecomendador}/${idOpcion}${esDental}`);
  }

  getColectivasAgrupacionesRecomendador(idOpcion: number, codIdioma: string, esDental: boolean): Observable<ColectivasAgrupacion> {
    return this.invocarSeguros<ColectivasAgrupacion>('GET',
      `salud/recomendador/colectivas-agrupacion-recomendador/${idOpcion}/${codIdioma}/${esDental}`
    );
  }

  getColectivaAgrupacion(idRecomendador: number, idOpcion: number, codIdioma: string, colectiva: string, esDental: boolean): Observable<ColectivasAgrupacion> {
    return this.invocarSeguros<ColectivasAgrupacion>('GET',
      `salud/recomendador/colectiva-agrupacion/${idRecomendador}/${idOpcion}/${codIdioma}/${colectiva}/${esDental}`
    );
  }

  getColectivasRecomendadas(idRecomendador: number, idOpcion: number, codIdioma: string, esDental: boolean): Observable<ColectivasAgrupacion> {
    return this.invocarSeguros<ColectivasAgrupacion>('GET', `salud/recomendador/colectivas-recomendadas/${idRecomendador}/${idOpcion}/${codIdioma}/${esDental}`);
  }

  getConfiguracionColectivas(codIdioma: string, colectivas: string[]): Observable<CategoriaColectivaIdiomas[]> {
    const params = colectivas.map(c => `colectivas=${c}`).join('&');
    return this.invocarSeguros<CategoriaColectivaIdiomas[]>('GET', `salud/recomendador/configuracion-colectivas/${codIdioma}?${params}`);
  }

  getIdOpcionRecomendador(request: ConsultarIdOpcionRecomendador): Observable<number> {
    return this.invocarSeguros<number>('POST', 'salud/recomendador/opcion-recomendador', request);
  }

  getPermisosRecomendador(idRecomendador: number): Observable<PermisosRecomendador> {
    return this.invocarSeguros<PermisosRecomendador>('GET', `salud/recomendador/permisos-recomendador/${idRecomendador}`);
  }

  getPreguntaInicial(idRecomendador: number, codIdioma: string, tipoDocumento: string, tipoCliente: string): Observable<PreguntaRecomendador> {
    return this.invocarSeguros<PreguntaRecomendador>('GET', `salud/recomendador/pregunta-inicial/${idRecomendador}/${codIdioma}/${tipoDocumento}/${tipoCliente}`);
  }

  getRecomendador(): Observable<Recomendador> {
    return this.invocarSeguros<Recomendador>('GET', 'salud/recomendador');
  }

  getColectivasRecomendador(blnDental: boolean): Observable<string[]> {
    return this.invocarSeguros<string[]>('GET', `salud/recomendador/colectivas/${blnDental}`);
  }
}
